import rest from '@modules/rest'

export const getCities = async ({ stateId, companyId }) => {
  if (!stateId) return [ null, [] ]

  try {
    const url = `/companies/proxy/companies/${companyId}/states/${stateId}/cities`
    const { data } = await rest.get(url)

    return [ null, data ]
  } catch (err) {
    return [ err, null ]
  }
}
